// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HistoryType } from './HistoryType';
class _HistoryTypeConverter {
    constructor() {
        this.ServerHistoryTypes = {
            0: HistoryType.QUOTE_LEVEL1,
            1: HistoryType.QUOTE_TRADES,
            2: HistoryType.QUOTE_ASK
        };
        this.LocalHistoryTypes = (() => {
            const rec = {};
            for (const serv in this.ServerHistoryTypes) {
                rec[this.ServerHistoryTypes[serv]] = parseFloat(serv);
            }
            return rec;
        })();
    }
    GetLocalHistoryType(serverType) {
        const res = this.ServerHistoryTypes[serverType];
        if (!isNullOrUndefined(res)) {
            return res;
        }
        return HistoryType.QUOTE_LEVEL1;
    }
    GetServerHistoryType(localType) {
        const res = this.LocalHistoryTypes[localType];
        if (!isNullOrUndefined(res)) {
            return res;
        }
        return 0;
    }
}
export const HistoryTypeConverter = new _HistoryTypeConverter();
